import { useQuery as o } from "@tanstack/vue-query";
import { computed as u, toValue as n } from "vue";
const i = ["ad-unit"], l = {
  all: i,
  lists: () => [...i, "list"],
  list: (t) => [...i, "list", t]
}, d = (t, s, e) => {
  const r = u(() => l.list(n(s)));
  return o({
    ...e,
    queryKey: r,
    queryFn: async () => t.adUnit.findAll(n(s))
  });
}, a = async (t, s, e) => {
  await t.prefetchQuery({
    queryKey: l.list(e),
    queryFn: async () => s.adUnit.findAll(e)
  });
};
export {
  l as adUnitKeys,
  a as prefetchAdUnitsList,
  d as useAdUnitsList
};
//# sourceMappingURL=queries.js.map
